import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { Delete } from './icons';
import { Button } from './buttons';
import { FormContext } from '../context/form-context';
import './Modal.scss';

const Modal = ({
  onAfterOpen = () => {},
  shouldCloseOnOverlayClick = true,
  showCloseButton = true,
  className = '',
  isOpen,
  onRequestClose,
  children
}) => {
  const { t } = useTranslation();

  const { isDirty } = useContext(FormContext);

  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldFocusAfterRender
      className={{
        base: className,
        afterOpen: 'modal--after-open',
        beforeClose: ''
      }}
      overlayClassName={{
        base: '',
        afterOpen: 'modal__overlay--after-open',
        beforeClose: ''
      }}
    >
      {showCloseButton && (
        <Button
          tabIndex="0"
          onKeyPress={onRequestClose}
          onClick={onRequestClose}
          className="modal__close-button"
          ariaLabel={t('modal.close')}
        >
          <Delete viewBox="8 8 16 16" />
        </Button>
      )}
      <div className="modal__header" />
      <div className="modal__contents">
        <div className="modal__contents-inner">{children}</div>
      </div>
      <div className="modal__footer" />
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  shouldCloseOnOverlayClick: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  className: PropTypes.string
};

export default Modal;
